import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    navigation: [
      { to: '/', label: 'Home' },
      { to: '/gallery', label: 'Gallery' },
      { to: '/faq', label: 'FAQ' },
      { to: '/blog', label: 'Blog' },
    ],
    catering: [
      { to: '/catering', label: 'Catering Menu' },
      { to: '/catering#quote', label: 'Get a Quote' },
    ],
    employee: [
      { to: '/employment', label: 'Apply for a Job', internal: true },
      { to: '/login', label: 'Employee Login', internal: true },
      { href: 'https://trashspy.neonforge.co', label: 'Trash Spy' },
    ],
  };

  return (
    <footer className="bg-piggy-bg-dark border-t border-gray-800">
      <div className="container mx-auto py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="text-2xl font-display font-bold">
              <span className="text-white">The Piggy</span>
              <span className="text-piggy-pink"> BBQ</span>
            </Link>
            <p className="mt-4 text-gray-400 text-sm leading-relaxed">
              Authentic Southern-style BBQ in Thief River Falls, Minnesota. Slow-smoked meats,
              homemade sides, and unforgettable flavors.
            </p>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {footerLinks.navigation.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-gray-400 hover:text-piggy-pink transition-colors text-sm"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Catering Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Catering</h3>
            <ul className="space-y-2">
              {footerLinks.catering.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-gray-400 hover:text-piggy-pink transition-colors text-sm"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Employee Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Employee Resources</h3>
            <ul className="space-y-2">
              {footerLinks.employee.map((link) => (
                <li key={link.label}>
                  {link.internal ? (
                    <Link
                      to={link.to}
                      className="text-gray-400 hover:text-piggy-pink transition-colors text-sm"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-piggy-pink transition-colors text-sm"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <div className="space-y-3 text-gray-400 text-sm">
              <p>123 3rd St E, 2nd Floor<br />Thief River Falls, MN 56701</p>
              <p>
                <a href="tel:+12186531031" className="hover:text-piggy-pink transition-colors">
                  (218) 653-1031
                </a>
              </p>
              <p>
                <a href="mailto:trf@piggy-bbq.com" className="hover:text-piggy-pink transition-colors">
                  trf@piggy-bbq.com
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-10 pt-8">
          <div className="text-center">
            <p className="text-gray-500 text-sm">
              &copy; {currentYear} The Piggy BBQ. All rights reserved.
            </p>
            <p className="text-gray-600 text-xs mt-2">
              Powered by{' '}
              <a
                href="https://neonforge.co"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-piggy-pink transition-colors"
              >
                Neon Forge LLC
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
